import React, { useEffect, useState } from "react";

import { Image } from "@src/components/Image";
import styles from "./FooterItem.module.scss";
import Button from "../../Button";
import handleOpenContent from "../../../Tabs/Content/helpers/handleOpenContent";

import { getAwsAssets } from "@src/utils";
import {
  hitDeeplinkPerformAction,
  hitDeeplinkExecutedV2,
} from "@src/utils/hitDeeplink";
import { COMMON_DEEPLINK_ACTIONS } from "@src/utils/constants";
import { directDeepLink } from "@src/common/deepLinks";

const FooterItem = ({
  icon,
  heading,
  descriptionIcon,
  descriptionText,
  descriptionValue,
  button,
  remove,
  increment,
  content,
  videoCta,
  isAgora,
}) => {
  // TIMER
  const [timeStamp, setTimeStamp] = useState(null);
  const [timer, setTimer] = useState(null);

  // EFFECTS
  useEffect(() => {
    if (descriptionValue && increment) {
      setTimeStamp(Math.floor(descriptionValue / 1000));
    } else {
      setTimer(descriptionValue);
    }
  }, [descriptionValue]);

  const timeoutRef = React.useRef(null);

  useEffect(() => {
    if (timeStamp) {
      timeoutRef.current = setTimeout(() => {
        if (increment) {
          setTimeStamp(timeStamp + increment);
        }
      }, 1000);
    }
    return () => clearTimeout(timeoutRef?.current);
  }, [timeStamp]);

  useEffect(() => {
    const dayBase = 60 * 60 * 24;
    const hourBase = 60 * 60;
    const minuteBase = 60;
    const days = Math.floor(timeStamp / dayBase),
      hours = Math.floor((timeStamp % dayBase) / hourBase),
      minutes = Math.floor((timeStamp % hourBase) / minuteBase),
      seconds = timeStamp % minuteBase;
    if (increment) {
      setTimer(
        `${days ? `${days}d` : ""}${hours ? `${hours}h` : ""}${minutes ? `${minutes}m` : ""
        }${seconds}s`
      );
    }
  }, [timeStamp]);

  return (
    <div className={styles.Footer}>
      <div className={styles.Footer__Left}>
        <div className={styles.Footer__Left__Details}>
          {icon && (
            <img
              src={icon || getAwsAssets("defaultThumbnail.svg", "content")}
              alt="X"
              width="48px"
              height="36px"
              onClick={() => {
                if (videoCta && content) {
                  handleOpenContent(content);
                }
              }}
            />
          )}
          <div className={styles.Footer__detail}>
            <p className={styles.Footer__detail__Info}>{heading}</p>

            {timer > 0 ? (
              <p className={styles.Footer__detail__event}>
                {descriptionIcon ? (
                  <Image
                    src={
                      descriptionIcon
                    }
                    alt="X"
                    width="14px"
                    height="9.15px"
                    layout="fixed"
                    objectFit="cover"
                  />
                ) : null}
                <div className={styles.Footer__detail__keyInfo}>
                  {descriptionText}
                </div>

                <div className={styles.Footer__detail__ValueInfo}>{timer}</div>
              </p>
            ) : null}
          </div>
        </div>

        {button && (
          <Button
            onClick={() => {
              if (content) {
                handleOpenContent(content);
              } else {
                hitDeeplinkPerformAction(
                  COMMON_DEEPLINK_ACTIONS.OPEN_GO_LIVE,
                  JSON.stringify(button.deeplink),
                  JSON.stringify(button.deeplink)
                );
              }
            }}
            xsmall
          >
            {button?.text}
          </Button>
        )}
      </div>

      <Image
        src={getAwsAssets("xCircle.svg", "layout")}
        alt="X"
        width="24px"
        height="24px"
        layout="fixed"
        objectFit="cover"
        onClick={remove}
      />
    </div>
  );
};

export default FooterItem;
